<template>
    <div class="row">
        <div v-if="newsItems.length > 0" v-for="(item, index) in newsItems" :key="index"
            class="col-12 col-md-6 row m-0 justify-content-center mt-5">
            <div class="card">
                <div class="img-container">
                    <img :src="$Img.url + 'SPA/' + item.ImagePath"></img>
                </div>
                <div class="p-5" style="text-align: left">
                    <label class="spa-title">{{ item.Title }}</label>
                    <p class="spa-content mt-2">{{ item.Content }}</p>
                </div>
            </div>
        </div>
        <div class="footer-stack"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            newsItems: [],
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            await this.GetNews();
        },
        async GetNews() {
            var post_data = {
                searchData: this.$Global.Base64Utils.utoa(
                    JSON.stringify({
                        ShopNO: this.$Global.Base64Utils.atou(
                            this.$cookieFunc.getCookie("ShopNO")
                        ),
                        SuplNO: "20250103000001",
                    })
                ),
            };

            this.$axios({
                method: "post",
                url: this.$URLJson.GetSpaNews,
                data: post_data,
            })
                .then((res) => {
                    var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
                    this.newsItems = data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}
</script>
<style scoped>
.card {
    height: 600px;
    width: 500px;
    border-radius: 0.5rem;
    box-shadow: 1px 1px 1px 1px #cbb79a;
    border:none;
}

.spa-title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: bold;
}

.spa-content {
    font-size: 1.25rem;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/News.vue